import React, {useState, useEffect} from "react";

import "./ProblemSearchResults.css";
import {Table} from "../../../common/table/Table";
import {findProblemsByCriteria} from "../../../../services/ProblemService";
import {appBaseURL} from "../../../../config/URLConfig";

export const ProblemSearchResults = ({context, setContext, navigateTo, setSpinnerText, showToaster}) => {

    const [searchResults, setSearchResults] = useState([]);

    useEffect(() => {
        const trackerSearchInput = context.problemSearchInput;
        const searchInput = {}

        if (trackerSearchInput.country) {
            searchInput.country = trackerSearchInput.country.label;
        }

        if (trackerSearchInput.province) {
            searchInput.province = trackerSearchInput.province.label;
        }

        if (trackerSearchInput.district) {
            searchInput.district = trackerSearchInput.district.label;
        }

        if (trackerSearchInput.subDistrict) {
            searchInput.subDistrict = trackerSearchInput.subDistrict.label;
        }

        if (trackerSearchInput.facility) {
            searchInput.facility = trackerSearchInput.facility.label;
        }

        if (trackerSearchInput.dateOfVisitFrom) {
            searchInput.dateOfVisitFrom = trackerSearchInput.dateOfVisitFrom;
        }

        if (trackerSearchInput.dateOfVisitTo) {
            searchInput.dateOfVisitTo = trackerSearchInput.dateOfVisitTo;
        }

        if (trackerSearchInput.topicArea) {
            searchInput.topicArea = trackerSearchInput.topicArea.topicArea;
        }

        if (trackerSearchInput.associatedPerson) {
            searchInput.personName = trackerSearchInput.associatedPerson.displayValue;
        }

        if (trackerSearchInput.problemStatement) {
            searchInput.problemStatement = trackerSearchInput.problemStatement;
        }

        if (trackerSearchInput.problemStatus) {
            searchInput.problemStatus = trackerSearchInput.problemStatus;
        }

        if (trackerSearchInput.grantName) {
            searchInput.grantName = trackerSearchInput.grantName;
        }

        const fetchData = async () => {
            setSpinnerText("Retrieving Problems");
            const [data, error] = await findProblemsByCriteria(context.username, searchInput);
            if (data) {
                if (data.responseStatus === "Success") {
                    setSearchResults(data.trackerSearchTableItems);
                } else {
                    showToaster(data);
                }
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }
            setSpinnerText(null);
        }
        fetchData();
    }, []);

    const handleRowClick = async (problem) => {
        if (context.activeSection === "Search Problems" || context.activeSection === "My Problems") {
            setContext((prevState) => ({
                ...prevState, problemToBeViewedExternalReference: problem.externalReference,
            }));
            navigateTo("problemTree");
        } else if (context.activeSection === "A3 Report") {
            window.open(appBaseURL + "/api/problem/generateA3Report?username=" + context.username + "&problemExternalReference=" + problem.externalReference);
        }
    }

    return (
        <div className="problem-search-results-container">
            <div className="problem-search-results-table-container">
                {searchResults &&
                <Table tableData={searchResults}
                       hiddenColumns={["problemId", "externalReference"]}
                       onRowClick={handleRowClick}
                       buttonText={"Change Search"}
                       onButtonClick={() => {
                           navigateTo("problemSearch");
                       }}/>}
            </div>
        </div>
    );
}
